var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEurSymbolR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.6 1.9A4 4 0 1 0 8.6 8.1M.8 4H6.4M.8 6H6.4",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.1
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEurSymbolR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eur-symbol-r.75f9c4511f2722636bbf14e07a198107.svg";